import React from 'react';
import { Text, View } from 'react-native-web';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import LineUnderPoint from '../../AuxiliaryComponent/MixComponent/LineUnderPoint';
import { getRegularFont } from '../../../../utils/Utils';

//= ========================================================================
const PinCodeFP = ({
  globJSON,
  simPlatform,
  notSkipped,
  TopTitle, withErrorTxt,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { auth } = globJSON.configurations.launch;
  const myStyles = {
    container: {
      alignSelf: 'center',
      marginTop: 25,
      height: 23,
      flexDirection: 'row',
    },
    opacityStyle: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
    lblError: {
      width: 240,
      height: 10,
      paddingVertical: 5,
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 8.1,
      textAlign: 'center',
      color: colors.negative_color,
    },
  };

  //= ====================================================================

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={globJSON.configurations.launch.auth.enter_your_pin_code}
      TopTitle={TopTitle}
      keyboardType="numbersKeyboard"
      slideshowRefs={slideshowRefs}
    >
      <View
        style={myStyles.container}
      >
        <LineUnderPoint
          globJSON={globJSON}
          backgroundColor={withErrorTxt ? colors.negative_color : colors.primary_cta_color}
        />
        <LineUnderPoint globJSON={globJSON} backgroundColor={withErrorTxt && colors.negative_color} />
        <LineUnderPoint globJSON={globJSON} backgroundColor={withErrorTxt && colors.negative_color} />
        <LineUnderPoint globJSON={globJSON} backgroundColor={withErrorTxt && colors.negative_color} />

      </View>
      {withErrorTxt && (
        <Text style={myStyles.lblError}>
          {auth.auth_pin_code_error}
        </Text>
      )}

      {notSkipped ? null : (
        <View style={myStyles.opacityStyle} />
      )}
    </FullPageSimulator>
  );
};
export default PinCodeFP;
